import { render, staticRenderFns } from "./ImagePopinGallery.vue?vue&type=template&id=70897152&scoped=true&lang=pug&"
import script from "./ImagePopinGallery.vue?vue&type=script&lang=js&"
export * from "./ImagePopinGallery.vue?vue&type=script&lang=js&"
import style0 from "./ImagePopinGallery.vue?vue&type=style&index=0&id=70897152&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70897152",
  null
  
)

export default component.exports